/* RESPONSIBLE TEAM: team-proactive-support */
export const linkTags = new RegExp(`<(\/)?a[^>]*>`, 'gm');
